export default __webpack_public_path__ + "static/media/us-vi.d7eae00a.svg";